<template>
  <div class="app-container">
    <div class="filter-container">
      <div class="menu">
        <el-button type="primary" @click="addPage">新增</el-button>

      </div>
      <el-table :data="tableData" style="width: 100%"  v-loading="loading" border>
        <el-table-column prop="id" v-if="false"></el-table-column>
        <el-table-column
          prop="description"
          label="链接应用说明"
          width="500"
        >
        </el-table-column>
        <el-table-column prop="urlCode" label="中转地址"> </el-table-column>
        <el-table-column prop="redirectUrl" label="跳转后地址"> </el-table-column>
        <el-table-column prop="operator" label="操作" width="200"
          ><template slot-scope="scope">
            <el-button @click="copyUrl(scope.row)" type="text" size="small"
              >复制中转地址</el-button
            >
            <el-button @click="editPage(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button
              @click="deleteData(scope.row)"
              type="text"
              size="small"
              style="color: red"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getList"
      />
      <!-- 弹出编辑弹窗 -->
      <monitor-popper
        :dialogVisible="dialogFlag"
        v-on:close-dialog="closeDialog"
        :tempData="tempData"
        :dialogType="dialogType"
        v-on:save-data="saveData"
      />
    </div>
  </div>
</template>
<script>
import {
  defaultMonitorLinkData,
  selectMonitorLink,
  deleteMonitorLink
} from '@/api/monitor'
import { cloneDeep } from 'lodash'
import Pagination from '@/components/Pagination/index.vue'
import MonitorPopper from '@/views/monitor/components/MonitorPopper.vue'

export default {
  name: 'Manage',
  components: {
    Pagination, MonitorPopper
  },
  data() {
    return {
      tableData: [],
      tempData: {},
      dialogType: '',
      total: 0,
      listQuery: { page: 1, limit: 20 },
      dialogFlag: false,
      baseUrl: '',
      loading: true
    }
  },
  created() {
    if (window.location.origin.indexOf('test-') > -1) {
      this.baseUrl = 'http://test-www.etsme.com/'
    } else if (window.location.origin.indexOf('test2-') > -1) {
      this.baseUrl = 'http://test2-www.etsme.com/'
    } else {
      this.baseUrl = 'https://www.etsme.com/'
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      await selectMonitorLink(this.listQuery).then((res) => {
        this.tableData = res.data.items
        this.total = res.data.total
        this.loading = false
      })
    },
    addPage() {
      this.dialogType = 'create'
      this.dialogFlag = true
      this.tempData = Object.assign({}, defaultMonitorLinkData)
      console.log(this.tempData)
    },
    editPage(row) {
      this.dialogType = 'edit'
      this.dialogFlag = true
      this.tempData = Object.assign({}, row)
    },
    closeDialog() {
      this.dialogFlag = false
    },
    resettempData() {
      this.tempData = cloneDeep(this.tempData)
    },
    saveData(status) {
      this.getList()
    },
    copyUrl(row){
      const input = document.createElement("input");
      input.value = this.baseUrl + "redirect/" + row.urlCode
      document.body.appendChild(input)
      input.select()
      document.execCommand("Copy")
      document.body.removeChild(input)
      this.$message.success("复制成功")
    },
    async deleteData(row) {
      await this.$confirm('此操作将永久删除该文记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tempData = Object.assign({}, row)
        deleteMonitorLink(this.tempData.urlCode).then((result) => {
          if (result && result.code === 20000 && result.data.result > 0) {
            const index = this.tableData.findIndex(
              (v) => v.urlCode === this.tempData.urlCode
            )
            this.tableData.splice(index, 1)
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
      })
    }
  }
}
</script>
<style scoped>
.edit-warp {
  border: 1px solid #c0c4cc;
}

</style>
